// aiDisclosure.ts — CORE-1567
//
// Как экраны называют получателя данных ИИ по контуру. Отдельный модуль без
// React — чтобы правило проверялось тестами.

import type { LegalOperator } from './operator';

/**
 * CORE-1567 — получатель в тексте раскрытия по контуру. В российском (оператор
 * АО) OpenAI не называется до подачи уведомлений в РКН — решение владельца 30.10
 * по ответу юриста 18; вне контура (AGAPE.IO Limited) раскрытие прежнее.
 */
export function moderationDisclosureCopy(operator: LegalOperator): { note: string; recipient: string } {
  return operator === 'intl'
    ? {
        note: 'Текст и изображения проверяет автоматический фильтр OpenAI Moderation до публикации',
        recipient: 'в OpenAI, L.L.C. (США) — сервису, который',
      }
    : {
        note: 'Текст и изображения проверяет автоматический фильтр до публикации',
        recipient: 'сервису искусственного интеллекта, который',
      };
}

/** CORE-1567 — пункт в редакции для оператора: вне контура РФ — свой текст `intl`, если он есть. */
export function pointForOperator<P extends { short: string; body: string; intl?: { short: string; body: string } }>(
  point: P,
  operator: LegalOperator,
): P {
  return operator === 'intl' && point.intl ? { ...point, ...point.intl } : point;
}

